import script from "./MobileLifestyle.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileLifestyle.vue?vue&type=script&setup=true&lang=ts"

import "./MobileLifestyle.vue?vue&type=style&index=0&id=163b62c0&lang=less&scoped=true"

import exportComponent from "D:\\sunrun_luo\\JK-neibu\\JKai-zhuzhan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-163b62c0"]])

export default __exports__